// OneDrive:IgnoreCodeCoverage

import { IFeature } from '@ms/odsp-utilities/lib/features/Features';

/**
 * This file contains the known list of features (a.k.a. flights or ramps) to be used by prefetch purposes.
 * The signature of one entry is:
 *  export const FeatureName: IFeature = { ODB: 100, ODC: "foo", Fallback: true };
 * ODB            Is the numerical value of the flight from the ExpFeature enumeration.
 *                Omit if the flight does not have a correspondent in ODB.
 * ODC            Is the string identifier in ODC.
 *                Omit if the flight does not have a correspondent ramp in ODC.
 * Fallback       The state of the flight, true = on false = off.
 *                The fallback is used only when the ODB or ODC flight is not applicable.
 *                For example: The Flight is an ODB flight with no ODC counterpart and the app runs in ODC mode.
 *                The fallback also allows declaring app only switches that are not known to the backend.
 *                Omit if false.
 */

export const RequestDatesInUtc: IFeature = { ODB: 865, OneDrive: true };
export const EnableWordWrsPreview: IFeature = { ODB: 270, OneDrive: true };
export const ListDataRenderOptionChange: IFeature = { ODB: 788, OneDrive: true };
export const EnablePowerPointWrsPreview: IFeature = { ODB: 268, OneDrive: true };
export const UseItemsScopeInSitesForODB = { ODB: 1211 /* ItemsScopeInSitesForODB */ };
export const UseItemsScopeInODB = { ODB: 1235 };
export const UseItemsScope = { ODB: 851 };
export const UseItemsScopeInPicker = { ODB: -852 };
export const UseItemsScopeInRecent = { ODB: -853 };
export const MergeDefaultViewODB: IFeature = { ODB: 1058 };
export const DoNotIncludeQuickLaunchInDeferredListData = { ODB: 1210 };
export const EnableCommentsInActivityFeed: IFeature = { ODB: 1174 };
